import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

type TenantDiscoveryResponse = {
  tenant?: string
}

type TenantDiscoveryRequest = {
  email: string
}

export const publicApi = createApi({
  reducerPath: 'publicApi',
  // Deliberately NOT anonymizingFetchBaseQuery (demo mode): this pre-auth response only
  // configures the Auth0 login flow and never renders in the UI; anonymizing the tenant
  // would break white-label sign-in.
  baseQuery: fetchBaseQuery({ baseUrl: envConfig.publicApiUrl }),
  tagTypes: ['IdentityProvider'],
  endpoints: (builder) => ({
    getAuthorizationTenant: builder.query<TenantDiscoveryResponse, TenantDiscoveryRequest>({
      query: (queryArg) => ({
        url: `/api/identity-provider/${queryArg.email}`
      }),
      providesTags: ['IdentityProvider']
    })
  })
})

export const { useGetAuthorizationTenantQuery } = publicApi
